<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [buttonClass]="'btn-outline-primary'"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section
      class="card mb-4"
      [ngClass]="
        investorDetailsFormGroupAlertShouldBeVisible
          ? 'border-danger border-2'
          : 'card-border-color-from-db'
      "
    >
      <div class="card-header card-header-color-from-db">
        {{
          'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.INVESTOR_DETAILS.TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
          [isEmailRequired]="false"
          [isEPUAPAddressVisible]="true"
          [isPeselVisible]="false"
          [isIdVisible]="false"
          [isPhoneNumberRequired]="false"
          [disabledNaturalPersonData]="true"
          [wasFormValidated]="submitted"
          [loggedUserAddressEditableByExternalForm]="true"
        ></app-investor-details>
      </div>

      @if (investorDetailsFormGroupAlertShouldBeVisible) {
        <div class="card-footer">
          <div class="alert alert-danger my-2">
            {{ 'FIELDS_REQUIRED' | translate }}
          </div>
        </div>
      }
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    @let areaFormControlAlertShouldBeVisible =
      submitted && !areAreaFormControlsValid();
    <section
      class="card mb-4"
      [ngClass]="
        areaFormControlAlertShouldBeVisible
          ? 'border-danger border-2'
          : 'card-border-color-from-db'
      "
    >
      <div class="card-header card-header-color-from-db">
        {{
          'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.PARCELS_AND_EXCLUSION_AREA'
            | translate
        }}
      </div>

      <div class="card-body">
        <gk-map
          [mapState]="mapState"
          (dispatch)="handleMapAction($event)"
        ></gk-map>

        <div class="my-2">
          @if (mapState.mapObjectTablesState[0].mapObjects.length) {
            <gk-map-object-table
              [mapState]="mapState"
              [mapObjectTableStateIndex]="0"
              (dispatch)="handleMapAction($event)"
            ></gk-map-object-table>
          }
        </div>
      </div>

      @if (areaFormControlAlertShouldBeVisible) {
        <div class="card-footer">
          @if (submitted && !areParcelsChosen()) {
            <div class="alert alert-danger mt-2">
              {{
                'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.PARCELS_REQUIRED'
                  | translate
              }}
            </div>
          }
          @if (submitted && !areExclusionAreasChosen()) {
            <div class="alert alert-danger mt-2">
              {{
                'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.EXCLUSION_AREA_REQUIRED'
                  | translate
              }}
            </div>
          }
        </div>
      }
    </section>

    <div class="row row-cols-1 row-cols-md-2">
      <div class="col">
        <section
          class="card mb-4"
          [ngClass]="
            checkExclusionPurposeFormControlValidAndFormValidated()
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <label
            class="card-header card-header-color-from-db"
            [attr.for]="controlName.ExclusionPurpose"
          >
            {{
              'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.EXCLUSION_PURPOSE'
                | translate
            }}
          </label>

          <div class="card-body">
            <select
              [name]="controlName.ExclusionPurpose"
              [id]="controlName.ExclusionPurpose"
              [formControlName]="controlName.ExclusionPurpose"
              class="form-select form-select-sm required"
              aria-required="true"
            >
              <option [ngValue]="null" hidden selected>
                {{
                  'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.PLACEHOLDERS.SELECT'
                    | translate
                }}
              </option>

              @for (
                exclusionPurpose of exclusionPurposes;
                track exclusionPurpose.id
              ) {
                <option [ngValue]="exclusionPurpose.id">
                  {{ exclusionPurpose.name }}
                </option>
              }
            </select>
          </div>
        </section>
      </div>

      <div class="col">
        <section
          class="card mb-4"
          [ngClass]="
            checkInvestmentCommencementDateFormControlValidAndFormValidated()
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <label
            class="card-header card-header-color-from-db"
            [attr.for]="controlName.InvestmentCommencementDate"
          >
            {{
              'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.INVESTMENT_COMMENCEMENT_DATE'
                | translate
            }}
          </label>

          <div class="card-body">
            <div class="input-group">
              <input
                class="form-control form-control-sm required"
                aria-required="true"
                [attr.placeholder]="
                  'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                "
                [id]="controlName.InvestmentCommencementDate"
                [name]="controlName.InvestmentCommencementDate"
                [formControlName]="controlName.InvestmentCommencementDate"
                ngbDatepicker
                #d="ngbDatepicker"
              />

              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="d.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </section>
      </div>
    </div>

    <section>
      <div class="card mb-4 card-border-color-from-db">
        <div class="card-header card-header-color-from-db">
          {{
            'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.LAND_VALUE'
              | translate
          }}
        </div>

        <div class="card-body">
          <label [attr.for]="controlName.LandValue">
            {{
              'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.LAND_VALUE_STATEMENT'
                | translate
            }}
          </label>
          <div class="input-group input-group-sm">
            <input
              [name]="controlName.LandValue"
              [id]="controlName.LandValue"
              class="form-control form-control-sm"
              [formControlName]="controlName.LandValue"
              type="number"
              (keypress)="validateFloatInput($event)"
            />
            <span class="input-group-text">PLN</span>
          </div>
        </div>
      </div>
    </section>

    <gk-attachments
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <button type="submit" class="btn btn-color-from-db">
      {{
        'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.FIELDS.SUBMIT_REQUEST'
          | translate
      }}
    </button>

    <app-request-preview-button
      class="ms-2"
      [buttonClass]="'btn-color-from-db'"
      [getPreviewRequestBody]="getRequestBody"
      [previewRequestUrl]="'/api/egib/wniosek/wylGrZProdRolnej/podglad'"
    ></app-request-preview-button>

    <app-doc-sign-info
      [messageText]="docSignMsgTxt"
      [messageType]="docSignMsgType"
      [docSignUrl]="docSignUrl"
      [docSignPending]="docSignPending"
    ></app-doc-sign-info>

    <div class="mt-2"><app-form-legend></app-form-legend></div>
  </form>
</div>
